import { render, staticRenderFns } from "./PcQrtyContent.vue?vue&type=template&id=63b93d70&"
import script from "./PcQrtyContent.vue?vue&type=script&lang=js&"
export * from "./PcQrtyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports